// 参考: https://github.com/ankane/vue-chartkick
import { lazyload } from '@/assets/scripts/lazy-load-module'

let chartId = 1
let createComponent = (ChartType) => {
  let chartProps = [
    'colors', 'curve', 'discrete', 'donut', 'download', 'label',
    'legend', 'library', 'max', 'min', 'points', 'refresh',
    'stacked', 'title', 'xtitle', 'xtype', 'ytitle'
  ]

  return {
    props: ['data', 'id', 'width', 'height'].concat(chartProps),
    template: '<div v-bind:id="chartId" v-bind:style="chartStyle">Loading...</div>',
    data() {
      return {
        chartId: null
      }
    },
    computed: {
      chartStyle() {
        // hack to watch data and options
        // 注释： updated() 只有在 Component上面绑定了的元素发生updated的时候才会触发。template 并没有{{data}}, 所以props的值发生改变并不会触发 updated()，导致图表刷新
        // 修复的方法是 让chartStyle与data关联，或者在template上面绑定一个值与data关联。
        // 为了避免显式在dom上面绑定 data 和 chartOptions， 使用hack的方式关联其与chartStyle
        if (this.data || this.chartOptions) {
          var color = '#999'
        }

        return {
          height: this.height || '300px',
          lineHeight: this.height || '300px',
          width: this.width || '100%',
          textAlign: 'center',
          color: color || '#999',
          fontSize: '14px',
          fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif'
        }
      },
      chartOptions() {
        var options = {}
        var props = chartProps
        for (var i = 0; i < props.length; i++) {
          var prop = props[i]
          if (this[prop] !== undefined) {
            options[prop] = this[prop]
          }
        }
        return options
      }
    },
    created() {
      this.chartId = this.chartId || this.id || ('chart-' + chartId++)
    },
    mounted() {
      this.chart = new ChartType(this.chartId, this.data, this.chartOptions)
    },
    updated() {
      this.chart.updateData(this.data, this.chartOptions)
    }
  }
}
export function dynamicImportChartkick(chartType) {
  return new Promise((resolve, reject) => {
    lazyload('chartkick').then(Chartkick => {
      resolve(createComponent(Chartkick[chartType]))
    }).catch(reject)
  })
}

// export default { dynamicImportChartkick }



// WEBPACK FOOTER //
// ./src/assets/scripts/charts.js